import React from 'react';

import { useAppDispatcher } from 'hooks/useAppDispatcher';
import { useAppState } from 'hooks/useAppState';
import { useAsyncProcess } from 'hooks/useAsyncProcess';

export const usePartnerTrialClients = () => {
  const runAsyncProcess = useAsyncProcess();

  const dispatch = useAppDispatcher();

  const {
    partnerDashboard: {
      trialClientsInvalidated,
      trialClients: partnerTrialClientsTableItems,
    },
  } = useAppState();

  const partnerTrialClientsCount = partnerTrialClientsTableItems.length;

  const partnerTrialLicensesCount = React.useMemo(() => {
    return partnerTrialClientsTableItems.reduce((acc, item) => {
      return acc + item.licensesCount;
    }, 0);
  }, [partnerTrialClientsTableItems]);

  React.useLayoutEffect(() => {
    if (trialClientsInvalidated) {
      runAsyncProcess((services) =>
        services.getPartnerTrialClientsTableItems().then((items) => {
          dispatch({
            name: 'PartnerClientsPage__TrialClientsTableItemsRecieved',
            items,
          });
        })
      );
    }
  }, [dispatch, runAsyncProcess, trialClientsInvalidated]);

  return {
    partnerTrialClientsCount,
    partnerTrialLicensesCount,
    partnerTrialClientsTableItems,
  };
};
